import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f5b22742"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "section" }
const _hoisted_2 = { class: "container mediabuying-section-wrapper content-wrapper" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "mediabuying-section-title pos" }
const _hoisted_5 = {
  style: {"margin-bottom":"10px"},
  class: "mediabuying-section-subtitle pos"
}
const _hoisted_6 = { class: "sub" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = { class: "landing-dialog" }
const _hoisted_9 = { class: "landing-dialog" }
const _hoisted_10 = { class: "wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_input = _resolveComponent("q-input")!
  const _component_Button = _resolveComponent("Button")!
  const _component_q_form = _resolveComponent("q-form")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t('contact_form.title')), 1),
          _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.$t('contact_form.subTitle')), 1)
        ]),
        _createElementVNode("h4", _hoisted_6, [
          _createTextVNode(_toDisplayString(_ctx.$t('contact_form.text')), 1),
          _hoisted_7,
          _createTextVNode(" " + _toDisplayString(_ctx.$t('contact_form.text2')), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_q_form, {
          ref: "form",
          style: {"width":"100%","max-width":"100%"},
          onSubmit: _ctx.onSubmit,
          onReset: _ctx.reset
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_q_input, {
                  "label-color": "white",
                  dense: "",
                  outlined: "",
                  placeholder: _ctx.$t('contact_form.name'),
                  modelValue: _ctx.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event)),
                  "lazy-rules": "",
                  rules: [_ctx.requiredField],
                  error: !!_ctx.errors.name,
                  "error-message": _ctx.errors.name,
                  onFocus: _cache[1] || (_cache[1] = 
                  () => {
                    this.errors.name = ''
                  }
                )
                }, null, 8, ["placeholder", "modelValue", "rules", "error", "error-message"]),
                _createVNode(_component_q_input, {
                  "label-color": "white",
                  dense: "",
                  outlined: "",
                  placeholder: _ctx.$t('contact_form.telegram'),
                  modelValue: _ctx.telegram,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.telegram) = $event)),
                  "lazy-rules": "",
                  rules: [_ctx.requiredField],
                  error: !!this.errors.telegram,
                  "error-message": this.errors.telegram,
                  onFocus: _cache[3] || (_cache[3] = 
                  () => {
                    this.errors.telegram = ''
                  }
                )
                }, null, 8, ["placeholder", "modelValue", "rules", "error", "error-message"])
              ])
            ]),
            _createElementVNode("div", null, [
              _createVNode(_component_q_input, {
                "label-color": "white",
                type: "textarea",
                onFocus: _cache[4] || (_cache[4] = 
                () => {
                  this.errors.message = ''
                }
              ),
                dense: "",
                outlined: "",
                placeholder: _ctx.$t('contact_form.message'),
                modelValue: _ctx.message,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.message) = $event)),
                "lazy-rules": "",
                rules: [_ctx.requiredField],
                error: !!this.errors.message,
                "error-message": this.errors.message
              }, null, 8, ["placeholder", "modelValue", "rules", "error", "error-message"])
            ]),
            _createVNode(_component_Button, {
              style: {"max-width":"100%"},
              type: "submit",
              text: _ctx.$t('btn.send')
            }, null, 8, ["text"])
          ]),
          _: 1
        }, 8, ["onSubmit", "onReset"])
      ])
    ])
  ]))
}